<template>
    <div class="components-container">
        <div class="filter-container">
            <el-select v-model="queryForm.Xnxqbm" filterable placeholder="学年学期" style="width:220px">
                <el-option v-for="item in xnxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-input v-model="queryForm.Cdmc" @keyup.enter.native="handleFilter" style="width: 220px" placeholder="场地名称" clearable>
            </el-input>
            <el-select v-model="queryForm.Cdlx" filterable placeholder="场地类型" style="width:220px">
                <el-option v-for="item in cdlxInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            <el-button @click="handleReset" type="gray" style="margin-left: 10px"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
            <el-button @click="addSite" type="success" style="margin-left: 10px"><i class="el-icon-circle-plus-outline"></i>&nbsp;添加</el-button>
            <!-- <el-button @click="handleFilter" type="warning" style="margin-left: 10px"><i class="el-icon-edit"></i>&nbsp;编辑</el-button> -->
            <el-button @click="delSite" type="danger" style="margin-left: 10px"><i class="el-icon-delete"></i>&nbsp;删除</el-button>
            <el-button @click="copyTerm" type="primary" style="margin-left: 10px"><i class="el-icon-document-copy"></i>&nbsp;复制</el-button>
        </div>

        <el-table :data="tableData" v-loading.body="tableLoading" :cell-style="handleCellStyle"
            element-loading-text="信息加载中" highlight-current-row border style="width: 100%" :height="mainTableHeight" ref="mainTable">
            <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                    <span>{{ (currentPage - 1) * limit + scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column label="学年学期" prop="xnxqmc" align="center" min-width="20%"></el-table-column>
            <el-table-column label="场地名称" prop="cdmc" align="center" min-width="20%"></el-table-column>
            <el-table-column label="场地类型" prop="cdlxmc" align="center" min-width="20%"></el-table-column>
            <el-table-column label="可容纳人数" prop="zdpkrl" align="center" width="200px"></el-table-column>
            <el-table-column label="可用时间" align="center" min-width="10%">
                <template slot-scope="scope">
                    <el-button size="small" @click="showTimeInfo(scope.row);" type="primary">
                        <i class="el-icon-tickets"></i>&nbsp;设置
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage"
                :page-sizes="[10, 20, 50]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>

        <!-- 场地tree -->
        <el-dialog :title="treeDialogTitle" :visible.sync="treeVisible" @closed="closeTreeDialog" width="500px" top="100px">
            <div class="tree-container" style="height:580px;overflow:auto;">
                <el-tree :data="treeData" show-checkbox node-key="id" :props="defaultProps" :default-expanded-keys="['0']" @check="handleCheck"></el-tree>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="formSubmiting" @click="commitForm">确 定</el-button>
                <el-button @click="treeVisible = false">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 星期时间段dialog -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @closed="closeDialog" width="900px" top="150px">
            <div class="dialog-footer" style="margin-bottom: 10px">
                <el-button @click="addTime" type="success" style="margin-left: 10px"><i class="el-icon-circle-plus-outline"></i>&nbsp;新建</el-button>
                <el-button @click="editTime" type="warning" style="margin-left: 10px"><i class="el-icon-edit"></i>&nbsp;编辑</el-button>
                <el-button @click="delTime" type="danger" style="margin-left: 10px"><i class="el-icon-delete"></i>&nbsp;删除</el-button>
            </div>
            <el-table :data="timeData" @current-change="timeCurrentChange" v-loading.body="tableLoading" :cell-style="handleCellStyle" class="timeTable"
                element-loading-text="信息加载中" highlight-current-row border style="width: 100%" height="500px" ref="timeTable" @row-click="rowClick">
                <template slot="empty">
                　　<span style="color: #909399;">{{ emptyValue }}</span>
                </template><br>
                <el-table-column label="序号" width="50" align="center">
                    <template slot-scope="scope">
                        <span>{{ (timecurrentPage - 1) * timelimit + scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="星期" prop="week" align="center" width="150px"></el-table-column>
                <el-table-column label="节次" prop="timeslot" :formatter="timeslotFormatter" align="center" min-width="50%"></el-table-column>
            </el-table>
            <div style="width:100%;height:20px;">
            </div>
        </el-dialog>

        <!-- 星期时间段编辑 -->
        <el-dialog :title="weekslotTitle" width="40%" :visible.sync="timeDialogVisible" @closed="timeDialogClose" top="280px" append-to-body>
            <el-form class="small-space" :model="timeForm" :rules="dateTimeRule" ref="timeForm" label-position="left" label-width="120px" style='width: 100%; margin-left:0px;'>
                <el-form-item label="星期" prop="week">
                    <el-select v-model="timeForm.week" placeholder="请选择星期" class="input-full" style="width:100%;" multiple clearable>
                        <el-option v-for="(item, index) in weekInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="节次" prop="timeslot">
                    <el-select v-model="timeForm.timeslot" placeholder="请选择节次" class="input-full" style="width:100%;" multiple clearable>
                        <el-option v-for="(item, index) in timeslotInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <!-- </div> -->
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="formSubmiting" @click="submitTime">确 定</el-button>
                <el-button @click="timeDialogClose">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 复制学期 -->
        <el-dialog :title="'复制'" :visible.sync="copyDialogVisible" @closed="copyDialogClose" width="600px" top="300px" append-to-body>
            <el-form class="small-space" :model="copyForm" :rules="rules" ref="copyForm" label-position="left" label-width="120px" style='width: 100%; margin-left:0px;'>
                <el-form-item label="来源学年学期" prop="originTerm">
                    <el-select v-model="copyForm.originTerm" placeholder="请选择来源学年学期" class="input-full" clearable @change="changeTerm($event)">
                        <el-option v-for="(item, index) in xnxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="目标学年学期" prop="targetTerm">
                    <el-select v-model="copyForm.targetTerm" placeholder="请选择目标学年学期" class="input-full" :disabled="disabled" clearable>
                        <el-option v-for="(item, index) in targetTermInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <!-- </div> -->
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="formSubmiting" @click="checkTerm">确 定</el-button>
                <el-button @click="copyDialogClose">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { confirmMsg } from "utils/message";
    import audit from 'views/audit/audit.vue';
    import auditList from 'views/audit/auditList.vue';

    export default {
        components: {
            audit,
            auditList,
        },
        data() {
            return {
                comboData: {
                    changeCode: null,
                    major: null,
                    class: null,
                },
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    Xnxqbm: null,
                    Xnxqmc: null,
                    Cdbh: null,
                    Cdmc: null,
                    Cdlx: null,
                    Qyzt: null,
                },
                timeForm: {
                    week: null,
                    timeslot: null,
                },
                copyForm: {
                    originTerm: null,
                    targetTerm: null,
                },
                xnxqInfo: [], //学年学期下拉框
                cdlxInfo: [], //场地类型下拉框
                weekInfo: [], //星期下拉框
                timeslotInfo: [], //时间段
                tableData: [],
                treeData: [],
                currentXnxq: null,
                currentPage: 1,
                limit: 10,
                total: null,
                timecurrentPage: 1,
                timelimit: 10,
                timetotal: null,
                tableLoading: true,
                selectRowData: null,
                mainTableHeight: 500,
                dialogTitle: "可用时间设置",
                dialogVisible: false,
                weekslotTitle: "",
                treeVisible: false,
                formSubmiting: false,
                detailDialogTitle: '',
                detailDialogTop: '150px',
                detailDialogVisible: false,
                treeDialogTitle: '',
                treeDialogHeight: 600,
                selectKeys: null,
                queryState: null,
                updateState: null,
                copyDialogVisible: false,
                targetTermInfo: [],
                disabled: true,
                checktermResult: null,
                copyType: null,
                timeData: [],
                timeDialogVisible: false,
                editType: null,
                selectedRow: null,
                oldweek: null,
                oldtimeslot: null,
                emptyValue: "",
                rules: {//表单验证
                    originTerm: [{ required: true, message: "请选择来源学期", trigger: "blur" }],
                    targetTerm: [{ required: true, message: "请选择目标学期", trigger: "blur" }],
                },
                dateTimeRule: {
                    week: [{required: true, message: "请选择日期",trigger: ["blur"],}],
                    timeslot: [{required: true, message: "请选择使用时间", trigger: ["blur"],}],
                },
                defaultProps: {
                  children: 'children',
                  label: 'label'
                },
            };
        },
        created() {
            this.weekInfo = [{"comboValue":"0","comboName":"周日"},{"comboValue":"1","comboName":"周一"},{"comboValue":"2","comboName":"周二"},{"comboValue":"3","comboName":"周三"},{"comboValue":"4","comboName":"周四"},{"comboValue":"5","comboName":"周五"},{"comboValue":"6","comboName":"周六"}];
            this.initParam();
        },
        mounted() {
            this.$nextTick().then(() => {
                //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
                //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
                this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;

                // 监听窗口大小变化
                let self = this;
                window.onresize = function() {
                    self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
                };

                $('.tree-container').css('height', window.innerHeight-150);
                // 监听窗口大小变化
                window.onresize = function() {
                    $('.tree-container').css('height', window.innerHeight-150);
                };
            });
        },
        methods: {
            auditStateFormatter(row){
                let str = '';
                if(row.zxqkshzt === '0'){
                    str = '待审核';
                }else if(row.zxqkshzt === '1'){
                    str = '审核中';
                }else if(row.zxqkshzt === '2'){
                    str = '审核通过';
                }else if(row.zxqkshzt === '3'){
                    str = '审核驳回';
                }
                return str;
            },
            //审状态列样式处理
            handleCellStyle({row, column, rowIndex, columnIndex}){
                let cellStyle;

                if(columnIndex === 7){
                    switch (row.auditState) {
                        case '1':
                            cellStyle = 'color: #00FF40 !important;';
                            break;
                        case '2':
                            cellStyle = 'color: #FE2E2E !important;';
                            break;
                        default:
                            cellStyle = '';
                    }

                    return cellStyle;
                }
            },
            initParam(){
                const paramMap = {
                    'name': 'combo_Info'
                }
                this.$api.teachingSiteManage.teachingSiteInfo.initOption({
                    data: paramMap
                }).then(response => {
                    this.xnxqInfo = response.data.data.xnxq;
                    this.currentXnxq = response.data.data.currentXnxq;
                    this.queryForm.Xnxqbm = this.currentXnxq;
                    this.cdlxInfo = response.data.data.cdlx;
                    this.queryList();
                    this.timeslotOption(this.currentXnxq);
                    //alert(JSON.stringify(response.data.data));
                }).catch(error => {
                    console.log(error);
                });
            },
            timeslotOption(xnxqbm) {
                const paramMap = {
                    'Xnxqbm': xnxqbm,
                }
                this.$api.teachingSiteManage.teachingSiteInfo.timeslotOption({
                    data: paramMap
                }).then(response => {
                    console.log(response.data.data.timeslot);
                    this.timeslotInfo = response.data.data.timeslot;
                }).catch(error => {
                    console.log(error);
                });
            },
            timeslotFormatter(row){
                const timeArray = row.timeslot.split(',');
                let resultStr = '';

                for(let i=0; i<timeArray.length; i++){
                    for(let j=0; j<this.timeslotInfo.length; j++){
                        if(timeArray[i] === this.timeslotInfo[j].comboValue){
                            resultStr += this.timeslotInfo[j].comboName+',';
                            break;
                        }
                    }
                }

                if(resultStr.length > 0) resultStr = resultStr.substring(0, resultStr.length-1);

                return resultStr;
            },
            queryList() {
                this.tableLoading = true;
                this.queryForm.pageNum = this.currentPage;
                this.queryForm.rowNum = this.limit;

                this.$api.teachingSiteManage.teachingSiteInfo.list({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    this.tableData = response.data.data.list;
                    this.tableLoading = false;
                    for(let i=0;i<this.tableData.length;i++){
                        if(this.selectRowData != null){
                            if(this.tableData[i].xnxqbm == this.selectRowData.xnxqbm && this.tableData[i].cdbh == this.selectRowData.cdbh){
                                this.selectRowData = this.tableData[i];
                            }
                        }
                    }
                    this.formatTimeData();
                    this.emptyValue = "默认节次无限制";
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            formatTimeData() {
                if(this.selectRowData != null){
                    this.timeData = [];
                    if(this.selectRowData.kysj != ''){
                        let weektime = this.selectRowData.kysj.split(",");
                        for(let i=0;i<weektime.length;i++){
                            let times = weektime[i].split("@");


                            let week_sp = times[0].split("#");
                            let week_num = "";
                            let week_name = "";
                            for(let j=0;j<week_sp.length;j++){
                                week_num += week_sp[j]+",";
                                week_name += this.weekInfo[week_sp[j]].comboName+",";
                            }
                            if(week_num!='' && week_name!=''){
                                week_num = week_num.substring(0,week_num.length-1);
                                week_name = week_name.substring(0,week_name.length-1);
                            }

                            let timeslot_sp = times[1].split("#");
                            let timeslot_num = "";
                            let timeslot_name = "";
                            for(let j=0;j<timeslot_sp.length;j++){
                                timeslot_num += timeslot_sp[j]+",";
                                timeslot_name += this.timeslotInfo[parseInt(timeslot_sp[j],10)].comboName+",";
                            }
                            if(timeslot_num!='' && timeslot_name!=''){
                                timeslot_num = timeslot_num.substring(0,timeslot_num.length-1);
                                timeslot_name = timeslot_name.substring(0,timeslot_name.length-1);
                            }
                            this.timeData.push({"weekid": week_num,"week": week_name,"timeslot":timeslot_num});
                        }
                    }
                }
            },
            handleFilter() {
                this.currentPage = 1;
                this.queryList();
            },
            handleReset() {
                this.limit = 10;
                this.currentPage = 1;
                this.queryForm.Cdbh = null;
                this.queryForm.Cdmc = null;
                this.queryForm.Cdlx = null;
                this.queryForm.Qyzt = null;
                this.tableLoading = false;
                this.queryList();
            },
            handlePageChange(val) {
                this.currentPage = val;
                this.queryList();
            },
            handleCurrentChange(val) {
               this.currentPage = val;
               this.queryList();
            },
            handleSizeChange(val) {
                this.limit = val;
                this.queryList();
            },
            addSite(){
                if(this.queryForm.Xnxqbm == ''){
                    this.$alert("请先选择学年学期", "提示", {
                        confirmButtonText: "确定",
                    });
                    return;
                }

                this.treeDialogTitle = "请选择要添加的场地";
                this.treeVisible = true;
                this.queryState = '0';
                this.updateState = '1';
                this.querySiteTree();
            },
            delSite(){
                if(this.queryForm.Xnxqbm == ''){
                    this.$alert("请先选择学年学期", "提示", {
                        confirmButtonText: "确定",
                    });
                    return;
                }

                this.treeDialogTitle = "请选择要删除的场地";
                this.treeVisible = true;
                this.queryState = '1';
                this.updateState = '0';
                this.querySiteTree();
            },
            querySiteTree(){
                const paramMap = {
                    'Xnxqbm': this.queryForm.Xnxqbm,
                    'Qyzt': this.queryState,
                }
                this.$api.teachingSiteManage.teachingSiteInfo.querySiteTree({
                    data: paramMap,
                }).then((response) => {
                    this.treeVisible = true;
                    this.treeData = response.data.data;
                }).catch(error => {
                    console.log(error);
                });
            },
            handleCheck(data,checkData){
                //console.log("checkedKeys:--"+checkData.checkedKeys);//节点id
                //console.log("checkedNodes:--"+checkData.checkedNodes);//节点数组
                this.selectKeys = checkData.checkedKeys;
            },
            commitForm() {
                if(this.selectKeys==null || this.selectKeys==''){
                    this.$message({
                        title: '提示',
                        message: '请至少选择一间教室！',
                        type: 'warning',
                        duration: 2000,
                    });
                }else{
                    this.formSubmiting = true;
                    const paramMap = {
                        'Xnxqbm':  this.queryForm.Xnxqbm,
                        'keys': this.selectKeys+"",
                        'Qyzt': this.updateState,
                    }
                    this.$api.teachingSiteManage.teachingSiteInfo.updateSite({
                        data: paramMap
                    }).then(response => {
                        let state = response.data.data.state;
                        let msg = response.data.data.msg;

                        if (state == 'Success') {
                            this.formSubmiting = false;
                            this.formVisible = false;
                            this.$notify({
                                title: "成功",
                                message: msg ? msg : "保存成功",
                                type: "success",
                                duration: 1500,
                            });
                            this.treeVisible = false;
                            this.selectKeys = null;
                            this.handleFilter();
                        }else{
                            this.formSubmiting = false;
                            this.$notify({
                                title: "失败",
                                message: msg ? msg : '保存失败',
                                type: "error",
                                duration: 3000,
                            });
                        }
                    }).catch(error => {
                        this.formSubmiting = false;
                        this.$notify({
                            title: '错误',
                            message: '编辑失败',
                            type: 'error',
                            duration: 3000,
                        });
                        console.log(error);
                    });
                }
            },
            timePageChange(val) {
                this.timecurrentPage = val;
                this.showTimeInfo();
            },
            timeCurrentChange(val) {
               //this.selectRowData = val;
            },
            timeSizeChange(val) {
                this.timelimit = val;
                this.timecurrentPage = 1;
                this.showTimeInfo();
            },
            showTimeInfo(rowData) {
                this.selectRowData = rowData;
                this.formatTimeData();
                this.dialogVisible = true;
            },
            addTime(){
                this.editType = "addTime";
                this.weekslotTitle = "新建";
                this.timeDialogVisible = true;
            },
            editTime(){
                if(this.selectedRow == null){
                    this.$message({
                        title: '提示',
                        message: '请选择一条记录',
                        type: 'warning',
                        duration: 2000,
                    });
                }else{
                    this.editType = "editTime";
                    this.weekslotTitle = "编辑";
                    this.oldweek = this.selectedRow.weekid;
                    this.oldtimeslot = this.selectedRow.timeslot;
                    this.timeForm.week = this.selectedRow.weekid.split(",");
                    this.timeForm.timeslot = this.selectedRow.timeslot.split(",");
                    this.timeDialogVisible = true;
                }
            },
            delTime(){
                if(this.selectedRow == null){
                    this.$message({
                        title: '提示',
                        message: '请选择一条记录',
                        type: 'warning',
                        duration: 2000,
                    });
                }else{
                    this.editType = "delTime";
                    this.saveTime();
                }
            },
            submitTime(){
                this.$refs.timeForm.validate(valid => {
                    if(valid){
                        this.saveTime();
                    }
                });
            },
            saveTime(){
                this.tableLoading = true;
                let weekinfo = "";
                let timeinfo = "";
                if(this.editType == "delTime"){
                    weekinfo = this.selectedRow.weekid;
                    timeinfo = this.selectedRow.timeslot+"";
                }else{
                    weekinfo = this.timeForm.week;
                    timeinfo = this.timeForm.timeslot+"";
                }
                const paramMap = {
                    'Xnxqbm': this.selectRowData.xnxqbm,
                    'Cdbh': this.selectRowData.cdbh,
                    'Kysj': this.selectRowData.kysj,
                    'Qyzt': this.selectRowData.qyzt,
                    'week': weekinfo+"",
                    'timeslot': timeinfo,
                    'oldweek': this.oldweek,
                    'oldtimeslot': this.oldtimeslot,
                    'type': this.editType,
                }
                this.$api.teachingSiteManage.teachingSiteInfo.saveWeekTimeslot({
                    data: paramMap,
                }).then((response) => {
                    this.tableLoading = false;
                    let state = response.data.data.state;
                    let msg = response.data.data.msg;

                    if (state == 'Success') {
                        this.formSubmiting = false;
                        this.formVisible = false;
                        this.$notify({
                            title: "成功",
                            message: msg ? msg : "编辑成功",
                            type: "success",
                            duration: 1500,
                        });
                        this.timeDialogClose();
                        this.queryList();
                    }else{
                        this.formSubmiting = false;
                        this.$notify({
                            title: "失败",
                            message: msg ? msg : '保存失败',
                            type: "error",
                            duration: 3000,
                        });
                    }
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            rowClick(row) {
                this.selectedRow = row;
            },
            closeDialog() {
                this.dialogVisible = false;
            },
            closeTreeDialog() {
                this.treeVisible = false;
            },
            timeDialogClose(){
                this.timeDialogVisible = false;
                this.selectedRow = null;
                this.timeForm.week = null;
                this.timeForm.timeslot = null;
                this.oldweek = null;
                this.oldtimeslot = null;
            },
            copyTerm(){
                this.copyDialogVisible = true;
            },
            copyDialogClose() {
                this.copyDialogVisible = false;
            },
            changeTerm(value) {
                this.disabled = false;
                this.targetTermInfo=[];
                for(var i=0;i<this.xnxqInfo.length;i++){
                    if(value != this.xnxqInfo[i].comboValue){
                        this.targetTermInfo.push({"comboValue": this.xnxqInfo[i].comboValue,"comboName":this.xnxqInfo[i].comboName});
                    }
                }
            },
            checkTerm(){
                this.tableLoading = true;
                const paramMap = {
                    'originTerm': this.copyForm.originTerm,
                    'targetTerm': this.copyForm.targetTerm,
                }
                this.$api.teachingSiteManage.teachingSiteInfo.checkTerm({
                    data: paramMap,
                }).then((response) => {
                    this.checktermResult = response.data.data.result;
                    this.tableLoading = false;
                    if(this.checktermResult == "success"){
                        this.copyType = "add";
                        this.submitCopy();
                    }else if(this.checktermResult == "目标学年学期场地已设置,是否要覆盖？"){
                        this.$confirm(this.checktermResult, '提示', {
                              confirmButtonText: '确定',
                              cancelButtonText: '取消',
                              type: 'warning'
                        }).then(() => {
                            this.copyType = "cover";
                            this.submitCopy();
                        }).catch(() => {

                        });
                    }else if(this.checktermResult == "来源学年学期场地未设置"){
                        this.$message({
                            title: '提示',
                            message: this.checktermResult,
                            type: 'warning',
                            duration: 2000,
                        });
                    }
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            submitCopy() {
                this.formSubmiting = true;
                const paramMap = {
                    'originTerm': this.copyForm.originTerm,
                    'targetTerm': this.copyForm.targetTerm,
                    'copyType': this.copyType,
                }
                this.$api.teachingSiteManage.teachingSiteInfo.copyTerm({
                    data: paramMap,
                }).then(response => {
                    this.formSubmiting = false;
                    this.$notify({
                        title: '成功',
                        message: '复制成功',
                        type: 'success',
                        duration: 1500,
                    });
                    this.copyDialogVisible = false;
                    this.copyForm.originTerm = null;
                    this.copyForm.targetTerm = null;
                    this.disabled = false;
                    this.handleFilter();
                }).catch(error => {
                    this.formSubmiting = false;
                    this.$notify({
                        title: '错误',
                        message: '复制失败',
                        type: 'error',
                        duration: 3000,
                    });
                    console.log(error);
                });
            },
            getCurrentFormatDate(){
                var date = new Date();
                var seperator1 = "-";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                var currentdate = year + seperator1 + month + seperator1 + strDate;
                return currentdate;
            },
        },
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// config.vue?2393f2ef